import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import type { ProjectStatus, ProjectSubmissionStatus } from '../types';

const PROJECT_VARIANTS: Record<ProjectStatus, 'default' | 'secondary' | 'outline'> = {
  published: 'default',
  draft: 'outline',
  archived: 'secondary',
};

/** Project status chip — staff surfaces only (pupil payloads carry no status). */
export function ProjectStatusBadge({ status }: { status: ProjectStatus }) {
  const { t } = useTranslation(['projects']);
  return <Badge variant={PROJECT_VARIANTS[status]}>{t(`projects:status.${status}`)}</Badge>;
}

const SUBMISSION_VARIANTS: Record<
  ProjectSubmissionStatus,
  'default' | 'secondary' | 'outline' | 'destructive'
> = {
  draft: 'outline',
  submitted: 'secondary',
  returned: 'destructive',
  graded: 'default',
};

/** Result status chip; `status = undefined` means the team never opened it. */
export function ProjectSubmissionStatusBadge({ status }: { status?: ProjectSubmissionStatus }) {
  const { t } = useTranslation(['projects']);
  if (!status) return <Badge variant="outline">{t('projects:submissionStatus.notStarted')}</Badge>;
  return (
    <Badge variant={SUBMISSION_VARIANTS[status]}>{t(`projects:submissionStatus.${status}`)}</Badge>
  );
}

/** Sticky late marker — computed once server-side at the first hand-in. */
export function ProjectLateBadge() {
  const { t } = useTranslation(['projects']);
  return <Badge variant="destructive">{t('projects:late')}</Badge>;
}
